var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    join = _require$doc$builders.join;

var UnaryOperation = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;

    if (node.isPrefix) {
      if (node.operator === 'delete') {
        return join(' ', [node.operator, path.call(_print, 'subExpression')]);
      }

      return concat([node.operator, path.call(_print, 'subExpression')]);
    }

    return concat([path.call(_print, 'subExpression'), node.operator]);
  }
};
module.exports = UnaryOperation;